import { playbackModes } from 'store/reducers/player';
import { popoutActions } from './actions-const';
import { loadOnDemandClip, loadStation, trackOnDemandPlaybackTime, loadLiveVideo } from './player-actions';

export function setStationInPopout(station, playbackMode) {
  return {
    type: popoutActions.POPOUT_SET_STATION,
    station,
    playbackMode,
  };
}

export function setClipInPopout(clip, playbackTime) {
  return {
    type: popoutActions.POPOUT_SET_CLIP,
    clip,
    playbackTime,
  };
}

export function setPlaybackTimeInPopout(playbackTime) {
  return {
    type: popoutActions.POPOUT_SET_PLAYBACK_TIME,
    playbackTime,
  };
}

export function setPlaybackDurationInPopout(playbackDuration) {
  return {
    type: popoutActions.POPOUT_SET_PLAYBACK_DURATION,
    playbackDuration,
  };
}

export function setIsPopoutPlayerActive(popoutPlayerIsActive) {
  return {
    type: popoutActions.TOGGLE_POPOUT_PLAYER,
    isPopoutPlayerActive: popoutPlayerIsActive,
  };
}

export function playMediaInPopout() {
  return async (dispatch, getState) => {
    const {
      popout: { playbackMode, station, clip, playbackTime },
    } = getState();
    if (station) {
      const load = playbackMode === playbackModes.LIVE_VIDEO ? loadLiveVideo : loadStation;
      dispatch(load(station));
    }
    if (clip) {
      if (playbackTime) {
        dispatch(trackOnDemandPlaybackTime(playbackTime));
      }
      dispatch(loadOnDemandClip(clip));
    }
  };
}
